import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { InMemoryCacheService, MessageType, UtilsService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class ProjectGuardService{

  constructor(
    private router: Router,
    public cache: InMemoryCacheService,
    private utils: UtilsService
  ) { }

  async canActivate(){
    if (!this.cache.currentProject) {
        this.utils.logger.info(`ProjectGuardService.canActivate() - No current project is set, redirecting to projects`);
        //force re route
        this.router.navigate(['/settings/manage/projects']);
        //warning message
        this.utils.errorMessage(MessageType.ALERT, 'No project selected, please select or create a project to continue.');
      return false;
    } else {
      return true;
    }
  }
}
